<template>
  <div>
    <ul class="grid-3 row-gap-4 list-reset col-gap-32">
      <li class="flex items-center" v-for="(incl, index) in displayingInclusions" :key="index">
        <div class="flex-none pr-3">
          <template v-if="incl.type === 'extra'">
            <svg style="fill: currentColor" width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_dollar"></use>
            </svg>
          </template>
          <template v-else>
            <svg width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_success"></use>
            </svg>
          </template>
        </div>
        <div class="flex-1">{{ incl.name }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";

import InclusionSubList from "../../components/core/InclusionSubList";
import { DIVE_CENTER_FACILITIES } from "../../helpers/constants";

export default {
  components: {
    InclusionSubList,
  },
  props: ["resortId"],
  data() {
    return {
      inclusions: [],
    };
  },
  computed: {
    orderedInclusions() {
      return orderBy(this.inclusions, ["order", "name"], ["asc", "asc"]);
    },

    displayingInclusions() {
      return [...this.included, ...this.extra];
    },
    included() {
      return this.orderedInclusions.filter((incl) => incl.type === "included");
    },
    extra() {
      return this.orderedInclusions.filter((incl) => incl.type === "extra");
    },
    notIncluded() {
      return this.orderedInclusions.filter(
        (incl) => incl.type === "not_included"
      );
    },
    showPopup() {
      return (
        this.notIncluded.length ||
        this.included.length > 6 ||
        this.extra.length > 6
      );
    },
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((res) => {
      this.inclusions = res.inclusions.filter(
        (incl) => incl.list_id !== DIVE_CENTER_FACILITIES
      );
    });
  },
};
</script>
